import React from 'react';
import { useLocation, useParams } from 'react-router-dom';
import ResultadoDiagnosticoForm from '../components/ResultadoDiagnosticoForm';

const ResultadoDiagnosticoPage = () => {
  const { resultadoId } = useParams();
  const location = useLocation();
  const isEditMode = Boolean(resultadoId);
  const protocoloMuestraInicial = location.state?.protocoloMuestra || '';
  const protocoloGeneralInicial = location.state?.protocoloGeneral || '';

  return (
    <section className="container page-shell">
      <div className="page-header">
        <div>
          <span className="section-kicker">{isEditMode ? 'Edicion' : 'Laboratorio'}</span>
          <h2 className="page-title">{isEditMode ? 'Editar resultado por muestra' : 'Resultado por muestra'}</h2>
          <p className="page-subtitle">
            {isEditMode
              ? 'Actualiza el resultado y vuelve al detalle del caso para seguir trabajando.'
              : 'Selecciona el protocolo general y carga los resultados de todas las muestras del caso en una sola vista.'}
          </p>
        </div>
        <img src="/logo-inta.png" alt="Logo INTA" className="page-header-logo" />
      </div>

      <ResultadoDiagnosticoForm
        protocoloMuestraInicial={protocoloMuestraInicial}
        protocoloGeneralInicial={protocoloGeneralInicial}
        resultId={resultadoId}
      />
    </section>
  );
};

export default ResultadoDiagnosticoPage;
